import { currency } from "Components/MUI_components/currencyFormatterTag"
import { LEDGER_TYPE_CODE } from "./LedgerTypeCode"
import { LEDGER_TYPE_NAME } from "./LedgeTypeName"
import { LOCAL_STORAGE } from "./LocalStorage"
import { GENERAL_LEDGER_SOURCE_VALUE } from "./generalLedgerSouurceValue"



  export const handleLedgerType = (code) => {
    switch (code) {
      case LEDGER_TYPE_CODE.CASH_BOOK_SH:
        return LEDGER_TYPE_NAME.CASH_BOOK_SH
      case LEDGER_TYPE_CODE.CA_P_AND_P_SH:
        return LEDGER_TYPE_NAME.CA_P_AND_P_SH
      case LEDGER_TYPE_CODE.SEYLAN_BANK_SH:
        return LEDGER_TYPE_NAME.SEYLAN_BANK_SH
      case LEDGER_TYPE_CODE.DFCC_SH:
        return LEDGER_TYPE_NAME.DFCC_SH
      case LEDGER_TYPE_CODE.HNB_SH:
        return LEDGER_TYPE_NAME.HNB_SH
      case LEDGER_TYPE_CODE.CC_DFCC_SH:
        return LEDGER_TYPE_NAME.CC_DFCC_SH
      case LEDGER_TYPE_CODE.CC_HNB_SH:
        return LEDGER_TYPE_NAME.CC_HNB_SH
      case LEDGER_TYPE_CODE.CASH_BOOK_ST:
        return LEDGER_TYPE_NAME.CASH_BOOK_ST
      case LEDGER_TYPE_CODE.CA_P_AND_P_ST:
        return LEDGER_TYPE_NAME.CA_P_AND_P_ST
      case LEDGER_TYPE_CODE.CA_FAZIL:
        return LEDGER_TYPE_NAME.CA_FAZIL
      case LEDGER_TYPE_CODE.CA_FAHIK:
        return LEDGER_TYPE_NAME.CA_FAHIK
      case LEDGER_TYPE_CODE.CA_FAHJI:
        return LEDGER_TYPE_NAME.CA_FAHJI
      case LEDGER_TYPE_CODE.SEYLAN_BANK_ST:
        return LEDGER_TYPE_NAME.SEYLAN_BANK_ST
      case LEDGER_TYPE_CODE.DFCC_ST:
        return LEDGER_TYPE_NAME.DFCC_ST
      case LEDGER_TYPE_CODE.HNB_ST:
        return LEDGER_TYPE_NAME.HNB_ST
      case LEDGER_TYPE_CODE.FAZIL_LOAN:
        return LEDGER_TYPE_NAME.FAZIL_LOAN
      case LEDGER_TYPE_CODE.FAHIK_LOAN:
        return LEDGER_TYPE_NAME.FAHIK_LOAN
      case LEDGER_TYPE_CODE.FAHJI_LOAN:
        return LEDGER_TYPE_NAME.FAHJI_LOAN
      case LEDGER_TYPE_CODE.LOCKER:
        return LEDGER_TYPE_NAME.LOCKER  
      default:
        return ""
    }
  }

export const getTransactionLabelBySourceCode = (sourceCode, fallback) => {
    switch (sourceCode) {
        case GENERAL_LEDGER_SOURCE_VALUE.PAYMENT_RECEIPT: 
            return "Payment Receipt Total";
        case GENERAL_LEDGER_SOURCE_VALUE.CASH_PAYMENT: 
            return "Cash Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT: 
            return "Cheque Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CARD_PAYMENT: 
            return "Card Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.BANK_PAYMENT: 
            return "Bank Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.RETURN_AMOUNT: 
            return "Return Amount";
        case GENERAL_LEDGER_SOURCE_VALUE.OVER_PAYMENT: 
            return "Over Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_AMOUNT: 
            return "Expenses";
        case GENERAL_LEDGER_SOURCE_VALUE.PAYMENT_VOUCHER: 
            return "Payment Voucher Total";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CASH_PAYMENT: 
            return "Supplier Cash Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT: 
            return "Supplier Cheque Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CARD_PAYMENT: 
            return "Supplier Card Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_BANK_PAYMENT: 
            return "Supplier Bank Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.PURCHASE_RETURN: 
            return "Purchase Return";
        case GENERAL_LEDGER_SOURCE_VALUE.SALES_RETURN: 
            return "Sales Return";
        case GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CASH_PAYMENT: 
            return "Customer Cheque Return Cash Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CHEQUE_PAYMENT: 
            return "Customer Cheque Return Cheque Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_BANK_PAYMENT: 
            return "Customer Cheque Return Bank Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CARD_PAYMENT: 
            return "Customer Cheque Return Card Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_CASH_BOOK: 
            return "Cash Book Brought Forward Amount";
        case GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_BANK: 
            return "Bank Brought Forward Amount";
        case GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_CREDIT_CARD: 
            return "Card Brought Forward Amount";
        case GENERAL_LEDGER_SOURCE_VALUE.ONLINE_TRANSFER_PAYMENT: 
            return "Online Transfer Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_ONLINE_TRANSFER_PAYMENT: 
            return "Supplier Online Transfer Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_ONLINE_PAYMENT: 
            return "Customer Cheque Return Online Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CASH_PAYMENT: 
            return "Expense Cash Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CHEQUE_PAYMENT: 
            return "Expense Cheque Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CARD_PAYMENT: 
            return "Expense Card Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_BANK_PAYMENT: 
            return "Expense Bank Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_ONLINE_PAYMENT: 
            return "Expense Online Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CHEQUES_MOVE_TO_BANK_PAYMENT: 
            return "Cheques Move to Bank Payment";
        case GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_RETURNED: 
            return "Cheque Payment Returned";
        case GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_REALIZED: 
            return "Cheque Payment Realized";
        case GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_IN_HAND: 
            return "Cheque in Hand";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_REALIZED: 
            return "Supplier Cheque Payment Realized";
        case GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_RETURNED: 
            return "Supplier Cheque Payment Returned";
        case GENERAL_LEDGER_SOURCE_VALUE.CASH_CONYROLLER_BROUGHT_FORWARD: 
            return "Cash Controller Brought Forward";
        case GENERAL_LEDGER_SOURCE_VALUE.CAPTAL_ACCOUNT_BROUGHT_FORWARD:
            return "Capital Account Brought Forward"    
        case GENERAL_LEDGER_SOURCE_VALUE.EXISTING_BROUGHT_FORWARD :
            return "Existing Brougt Forward"    
        default: 
            return fallback || "";
    }
};
 
export const currentLocationCode = () => {
  const locationCodeItem = localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION);
  const locationCode = locationCodeItem ? JSON.parse(locationCodeItem).code : '';
  return locationCode;
}
